// ─── src/hooks/useMentors.ts ──────────────────────────────────────────────────

import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getMentors } from "../api/mentors";
import type { MentorParams } from "../types/mentor";

export const mentorKeys = {
  all:  ["mentors"] as const,
  list: (params: MentorParams) => [...mentorKeys.all, "list", params] as const,
};

export const useMentors = (params: MentorParams) =>
  useQuery({
    queryKey: mentorKeys.list(params),
    queryFn:  () => getMentors(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
